var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { BillApi } from '@ClientApi/billApi';
export const setupIntentRequiresMicrodeposits = (setupIntent) => {
    var _a;
    return Boolean((setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.status) === 'requires_action' && ((_a = setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.next_action) === null || _a === void 0 ? void 0 : _a.type) === 'verify_with_microdeposits');
};
export const useStripeSubscriptionAndCheckout = (company, onError) => {
    const [stripeCheckoutSession, setStripeCheckoutSession] = React.useState(null);
    const [activeStripeSubscription, setActiveStripeSubscription] = React.useState(null);
    const [processingPaymentInfo, setProcessingPaymentInfo] = React.useState(false);
    function getSubscriptionAndCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [res, setup] = yield Promise.allSettled([BillApi.getSubscription(), BillApi.getInProgressSetupIntent()]);
                if ((res.status === 'fulfilled' && !res.value.subscription) || res.status === 'rejected') {
                    const { subscription, checkoutSession } = yield BillApi.createSubscription(company.billing_plan, true);
                    setActiveStripeSubscription(subscription);
                    setStripeCheckoutSession(checkoutSession);
                }
                else {
                    setActiveStripeSubscription(res.value.subscription);
                    if (setup.status === 'fulfilled' && setupIntentRequiresMicrodeposits(setup.value)) {
                        setStripeCheckoutSession(setup.value);
                    }
                    else {
                        const createCheckoutSessionRes = yield BillApi.createSetupIntent(res.value.subscription.id);
                        setStripeCheckoutSession(createCheckoutSessionRes.data);
                    }
                }
            }
            catch (err) {
                onError === null || onError === void 0 ? void 0 : onError(err);
            }
        });
    }
    React.useEffect(() => {
        getSubscriptionAndCheckout();
    }, []);
    function onUpdateStripePaymentMethod(paymentMethodId) {
        return __awaiter(this, void 0, void 0, function* () {
            setStripeCheckoutSession(null);
            setProcessingPaymentInfo(true);
            try {
                return yield BillApi.updatePaymentMethod(paymentMethodId, activeStripeSubscription.id);
            }
            catch (err) {
                onError === null || onError === void 0 ? void 0 : onError(err);
            }
            finally {
                setProcessingPaymentInfo(false);
            }
        });
    }
    function cancelStripeCheckoutSession() {
        return __awaiter(this, void 0, void 0, function* () {
            yield BillApi.cancelSetupIntent(stripeCheckoutSession.id);
            setStripeCheckoutSession(null);
            setActiveStripeSubscription(null);
            yield getSubscriptionAndCheckout();
        });
    }
    return {
        stripeCheckoutSession,
        activeStripeSubscription,
        processingPaymentInfo,
        setStripeCheckoutSession,
        cancelStripeCheckoutSession,
        setActiveStripeSubscription,
        onUpdateStripePaymentMethod
    };
};
